import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import useGetSeries from './series-app/methods/useGetSeries';

import { DataProvider, useStore } from './series-app/context/store';
import Cards from './series-app/components/Cards';
import LoadMore from './series-app/components/LoadMore';

function SeriesApp() {
	const { state } = useStore();

	const { getSeries } = useGetSeries();

	useEffect(() => {
		getSeries();
	}, [state.init]);

	if ('undefined' !== typeof state && null !== state.series) {
		return (
			<div className="series-app">
				<Cards />
				<LoadMore />
			</div>
		);
	}

	return '';
}

const seriesCards = document.getElementById('series-app');

if (null !== seriesCards) {
	ReactDOM.render(
		<DataProvider>
			<SeriesApp tripID={seriesCards.getAttribute('data-trip-id')} />
		</DataProvider>,
		seriesCards
	);
}
